import React from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';

import * as Auth from 'auth/containers';
import { Layout } from 'auth/components';

const AuthRoutes = ({ match }) => {
  const url = match.url.replace(/\/$/, '');
  return (
    <Layout>
      <Switch>
        <Route exact path={`${url}/login`} component={Auth.Login} />
        <Route exact path={`${url}/recover_password`} component={Auth.RecoverPassword} />
        <Route exact path={`${url}/reset_password`} component={Auth.ResetPassword} />
        <Route exact path={`${url}/complete_info`} component={Auth.CompleteInfo} />
        <Route exact path={`${url}/update_info`} component={Auth.UpdateInfo} />
        <Route exact path={`${url}/logout`} component={Auth.Logout} />
        <Route>
          <Redirect to={`${url}/login`} />{' '}
        </Route>
      </Switch>
    </Layout>
  );
};

export default AuthRoutes;



// WEBPACK FOOTER //
// src/modules/auth/routes/AuthRoutes.js